import { useMutation } from 'react-query';
import { resetPassword } from 'src/services/api/auth';

function useResetPassword() {
  return useMutation(({ token, password }) => resetPassword(token, password));
}

export default useResetPassword;
